import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=4d9c3a7c&scoped=true&"
import script from "./footprint.vue?vue&type=script&lang=js&"
export * from "./footprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c3a7c",
  null
  
)

export default component.exports